import { render, staticRenderFns } from "./PortraitOne.vue?vue&type=template&id=6bb3bd31&scoped=true"
import script from "./PortraitOne.vue?vue&type=script&lang=js"
export * from "./PortraitOne.vue?vue&type=script&lang=js"
import style0 from "./PortraitOne.vue?vue&type=style&index=0&id=6bb3bd31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb3bd31",
  null
  
)

export default component.exports